import advancedFilters from './advancedFilters.json';
import agentBots from './agentBots.json';
import agentMgmt from './agentMgmt.json';
import attributesMgmt from './attributesMgmt.json';
import auditLogs from './auditLogs.json';
import automation from './automation.json';
import bulkActions from './bulkActions.json';
import campaign from './campaign.json';
import campaignPtBr from '../pt_BR/campaign.json';
import calendar from './calendar.json';
import cannedMgmt from './cannedMgmt.json';
import chatlist from './chatlist.json';
import companies from './companies.json';
import components from './components.json';
import contact from './contact.json';
import contactFilters from './contactFilters.json';
import contentTemplates from './contentTemplates.json';
import conversation from './conversation.json';
import csatMgmt from './csatMgmt.json';
import customRole from './customRole.json';
import datePicker from './datePicker.json';
import emoji from './emoji.json';
import general from './general.json';
import generalSettings from './generalSettings.json';
import inbox from './inbox.json';
import inboxMgmt from './inboxMgmt.json';
import integrationApps from './integrationApps.json';
import integrations from './integrations.json';
import labelsMgmt from './labelsMgmt.json';
import login from './login.json';
import macros from './macros.json';
import mfa from './mfa.json';
import onboarding from './onboarding.json';
import report from './report.json';
import resetPassword from './resetPassword.json';
import search from './search.json';
import salesPipeline from './salesPipeline.json';
import sessionLimit from './sessionLimit.json';
import setNewPassword from './setNewPassword.json';
import settings from './settings.json';
import signup from './signup.json';
import sla from './sla.json';
import snooze from './snooze.json';
import teamsSettings from './teamsSettings.json';
import yearInReview from './yearInReview.json';
import webhooks from './webhooks.json';
import whatsappTemplates from './whatsappTemplates.json';

const campaignBulk = {
  CAMPAIGN: {
    ...campaign.CAMPAIGN,
    WHATSAPP: {
      ...campaign.CAMPAIGN.WHATSAPP,
      BULK: campaignPtBr.CAMPAIGN.SMS.BULK,
    },
  },
};

export default {
  ...advancedFilters,
  ...agentBots,
  ...agentMgmt,
  ...attributesMgmt,
  ...auditLogs,
  ...automation,
  ...bulkActions,
  ...campaign,
  ...campaignBulk,
  ...calendar,
  ...cannedMgmt,
  ...chatlist,
  ...companies,
  ...components,
  ...contact,
  ...contactFilters,
  ...contentTemplates,
  ...conversation,
  ...csatMgmt,
  ...customRole,
  ...datePicker,
  ...emoji,
  ...general,
  ...generalSettings,
  ...inbox,
  ...inboxMgmt,
  ...integrationApps,
  ...integrations,
  ...labelsMgmt,
  ...login,
  ...macros,
  ...mfa,
  ...onboarding,
  ...report,
  ...resetPassword,
  ...search,
  ...salesPipeline,
  ...sessionLimit,
  SESSION_LIMIT: {
    ...sessionLimit.SESSION_LIMIT,
    TITLE: 'Limite de sessões ativas atingido',
    DESCRIPTION:
      'Você atingiu o limite de sessões ativas. Encerre uma sessão antes de entrar.',
    END: 'Encerrar',
    END_ALL: 'Encerrar todas as sessões',
    LOG_IN: 'Entrar',
    CANCEL: 'Voltar para o login',
    UNKNOWN_DEVICE: 'Dispositivo desconhecido',
    STARTED: 'Iniciada',
  },
  ...setNewPassword,
  ...settings,
  ...signup,
  ...sla,
  ...snooze,
  ...teamsSettings,
  ...webhooks,
  ...yearInReview,
  ...whatsappTemplates,
};
